import React, { useState } from 'react';
import { API_URL } from '../services/api';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import axios from 'axios';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    console.log('Attempting login with:', formData);
    console.log('Current host:', window.location.hostname);
    console.log('API URL:', `${API_URL}/api/auth/login`);

    try {
      const response = await axios.post(`${API_URL}/api/auth/login`, formData, {
        withCredentials: true
      });
      console.log('Login response:', response.data);

      // Guardar en localStorage
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));

      // Verificar que se guardó
      console.log('Token guardado:', localStorage.getItem('token'));
      console.log('Usuario guardado:', localStorage.getItem('user'));

      // Mostrar mensaje de éxito
      setSuccess(true);
      setError('');

      // Navegar al admin con un pequeño delay para asegurar que todo se guardó
      setTimeout(() => {
        console.log('Navegando a /admin...');
        navigate('/admin');
      }, 1000);
    } catch (error: any) {
      console.error('Login error:', error);
      console.error('Error response:', error.response);

      // Mensaje de error más detallado
      let errorMessage = 'Error al iniciar sesión';

      if (error.response) {
        // El servidor respondió con un error
        errorMessage = error.response.data?.message || `Error del servidor: ${error.response.status}`;
      } else if (error.request) {
        // No se recibió respuesta
        errorMessage = 'No se pudo conectar con el servidor';
      } else {
        // Error de configuración
        errorMessage = error.message || 'Error desconocido';
      }

      setError(errorMessage);
      console.error('Error detallado:', errorMessage);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
          }}
        >
          <Box
            sx={{
              width: 50,
              height: 50,
              borderRadius: '50%',
              bgcolor: 'primary.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2,
            }}
          >
            <LockOutlinedIcon sx={{ color: 'white' }} />
          </Box>

          <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
            Panel de Administración
          </Typography>

          {error && (
            <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ width: '100%', mb: 2 }}>
              ¡Login exitoso! Redirigiendo al panel de administración...
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%' }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Correo Electrónico"
              name="email"
              autoComplete="email"
              autoFocus
              value={formData.email}
              onChange={handleChange}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Contraseña"
              type="password"
              id="password"
              autoComplete="current-password"
              value={formData.password}
              onChange={handleChange}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              color="primary"
            >
              Iniciar Sesión
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;